module.exports = __webpack_public_path__ + "static/media/girl.62607c47.svg";